import styled from 'styled-components'

export const SelectLabel = styled.div`
  color: ${(p) => p.theme.uiKit.colors.global.grey.grey700};
  font-weight: 600;
  margin-bottom: 4px;
`
